import { useTranslation } from "react-i18next";
import {ReactComponent as CloseIcon} from "../../images/full-screen-close.svg";
import React, {useEffect, useRef, useState} from "react";

import {Dialog} from '@base-ui/react/dialog';
import styles from "./YuJaDialog.module.css";
import {Button} from "@base-ui/react/button";
import {getSafeURL} from "../../utils/helpers";

export const YuJaImageViewer = ({imageURL="", imageAlt="", onHandleClose, showViewer, setShowViewer}) => {
    const { t } = useTranslation();
    const safeImageURL = getSafeURL(imageURL);

    return (
        <Dialog.Root open={showViewer} onOpenChange={setShowViewer}>
            <Dialog.Portal>
                <Dialog.Backdrop className={styles.Backdrop} style={{background: "#000", opacity: 0.7}}/>
                <Dialog.Viewport className={styles.Viewport}>
                    <Dialog.Popup className={styles.Popup}>
                        <Button
                            style={{position: "fixed", top: "2rem", right: "2rem"}}
                            onClick={onHandleClose}
                            aria-label={t("accessibility.exitEnlargeView")}
                        >
                            <CloseIcon/>
                        </Button>
                        <img
                            alt={imageAlt}
                            src={safeImageURL}
                            style={{maxWidth: "100%", maxHeight: "100%", background: "#FFF"}}
                        />
                    </Dialog.Popup>
                </Dialog.Viewport>
            </Dialog.Portal>
        </Dialog.Root>
    );
}